import { ShieldCheck, Building2, Sprout, Layers } from "lucide-react";
import { FEATURES, IMAGES } from "@/data/content";
import { Reveal } from "@/components/Reveal";

const ICONS = [ShieldCheck, Building2, Sprout, Layers];

export const Intro = () => {
  return (
    <section className="relative bg-obsidian py-24 sm:py-32" data-testid="intro-section">
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Left: intro copy */}
          <div className="lg:col-span-7">
            <Reveal className="flex items-center gap-3 mb-8">
              <span className="text-xs uppercase tracking-[0.3em] text-brand font-semibold">
                Who We Are
              </span>
              <span className="h-px w-16 bg-white/15" />
            </Reveal>
            <Reveal
              as="h2"
              delay={0.05}
              className="font-display font-bold uppercase tracking-tighter text-[#f2f4f0] text-3xl sm:text-5xl lg:text-6xl leading-[0.95]"
            >
              Built for commercial ground,
              <span className="text-[#8d948f]"> not weekend yards.</span>
            </Reveal>
            <Reveal
              as="p"
              delay={0.1}
              className="mt-8 max-w-2xl text-lg text-[#c7ccc4] leading-relaxed"
            >
              Delta Grassmasters started in the heart of Arkansas' lower
              Mississippi Delta Region in Helena, Arkansas. We are client
              focused and provide top quality service to all of our clients —
              no job is too small or large. Our staff is trained with the
              latest techniques and horticultural practices of landscaping.
            </Reveal>
            <Reveal delay={0.15} className="mt-8 border-l-2 border-brand pl-5">
              <p className="text-sm uppercase tracking-[0.2em] text-[#8d948f]">
                Service Area
              </p>
              <p className="mt-1 text-base text-[#f2f4f0] font-medium">
                Based in North Little Rock, AR — serving clients across
                Arkansas and Mississippi.
              </p>
            </Reveal>
          </div>

          {/* Right: image */}
          <div className="lg:col-span-5">
            <Reveal delay={0.1} className="relative">
              <div className="relative overflow-hidden">
                <img
                  src={IMAGES.corporateLawn}
                  alt="Manicured commercial property lawn beside corporate building"
                  className="w-full h-[380px] lg:h-[460px] object-cover"
                />
                <div className="absolute inset-0 ring-1 ring-inset ring-white/10" />
              </div>
              <div className="absolute -bottom-5 -left-3 sm:-left-5 bg-brand px-6 py-4">
                <p className="font-display font-extrabold text-[#0b120a] text-2xl leading-none">
                  AR + MS
                </p>
                <p className="text-[11px] uppercase tracking-widest text-[#0b120a]/80 mt-1">
                  Licensed & Insured
                </p>
              </div>
            </Reveal>
          </div>
        </div>

        {/* Feature highlights */}
        <div className="mt-24 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {FEATURES.map((f, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal
                key={f.title}
                delay={i * 0.08}
                className="bg-obsidian p-8 group hover:bg-surface transition-colors duration-300"
                data-testid={`feature-${i}`}
              >
                <Icon className="h-8 w-8 text-brand mb-6 transition-transform duration-300 group-hover:-translate-y-1" />
                <h3 className="font-display font-bold uppercase tracking-tight text-lg text-[#f2f4f0] leading-tight">
                  {f.title}
                </h3>
                <p className="mt-3 text-sm text-[#8d948f] leading-relaxed">
                  {f.body}
                </p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
